import React, { useState, useEffect } from 'react';
import CategoryList from '../../components/CategoryList';
import axios from 'axios';
import { TableLoader } from '../../components/ContentLoader';
import { alertLoadingError } from '../../components/Confirm';
import { useTranslation } from 'react-i18next';

const DeclarationOfPerformance = ({ market }) => {
    const [dops, setDops] = useState(null)
    const [error, setError] = useState(false)
    const { t } = useTranslation();

    useEffect(() => {
        axios({
            method: 'get',
            baseURL: process.env.REACT_APP_CONTURA_BASE_URL,
            url: '/rest-api/mediaApi/files',
            params: {
                market: market,
                contentType: 'dop'
            }
        }).then((res) => {
            setDops(res.data[0]);
        }).catch((error) => {
            setError(true)
            alertLoadingError(t)
        });
    }, [t, market]);

    const ExtendedCategoryList = ({ mainFolder }) => {
        return (
            <>
                {mainFolder.items.map((folder, index) => (
                    <div
                        key={index}
                        className="list-category-item list-category-item--extended">
                        <div className="list-category-title list-category-title--extended">
                            <h2> {folder.name}</h2>

                        </div>
                        <div className="">
                            <CategoryList items={folder.items} />
                        </div>
                    </div>
                ))}
            </>
        )
    };

    return (
        <div className="main-content">
            <div className="content-primary">
                <h1>
                    {t('media.high-res.title')}
                </h1>
                <p>
                    {t('media.high-res.intro')}
                </p>
            </div>
            {dops &&
                <div className="content-secondary">
                    <div className="list-category-items list-category-items--extended">
                        <ExtendedCategoryList mainFolder={dops} />
                    </div>
                </div>
            }
            {!dops && !error &&
                <TableLoader />
            }
        </div>
    );
}

export default DeclarationOfPerformance;